;(function(){
// Remove pasted prototype section labels if a stale rendered Shopify/edge object serves them.
function removePrototypeLabels(){
  var patterns = [
    /^(\d+\.\s*)?(TOP BAR \+ COUNTDOWN|HERO|STATS BAR|PAS AGITATION|PRODUCT SECTION|FEATURED QUOTE|RESULTS GRID|SECTION INTRO)$/i,
    /^STICKY DESKTOP HEADER/i,
    /^(REASON \d|INLINE TESTIMONIAL \+ MID CTA|MID CTA|COMPARISON TABLE|VIDEO TESTIMONIALS \+ PLATFORMS|TIMELINE|TESTIMONIAL GRID|PRICING \/ BUY BOX|DOCTOR SECTION|FAQ|THE MATH|FINAL CTA|FOOTER|STICKY MOBILE CTA)$/i
  ];
  var walker = document.createTreeWalker(document.body || document.documentElement, NodeFilter.SHOW_TEXT);
  var nodes = [];
  var node;
  while ((node = walker.nextNode())) {
    var text = (node.nodeValue || '').replace(/\s+/g, ' ').trim();
    if (text && patterns.some(function(pattern){ return pattern.test(text); })) nodes.push(node);
  }
  nodes.forEach(function(node){ node.parentNode && node.parentNode.removeChild(node); });
}
if (document.body) removePrototypeLabels();
document.addEventListener('DOMContentLoaded', removePrototypeLabels);

// FAQ accordion
document.querySelectorAll('.faq-q').forEach(function(btn){
  btn.addEventListener('click',function(){
    var item=btn.parentElement,wasOpen=item.classList.contains('open');
    document.querySelectorAll('.faq-item').forEach(function(i){i.classList.remove('open')});
    if(!wasOpen)item.classList.add('open');
  });
});



// Buy box logic
(function(){
  var plans={
    m1:{summary:'Selected: <b>Subscription · 1‑Month Supply · $99</b>. Save $50, get free shipping, and cancel anytime. Prescription requests require licensed clinician review before fulfillment.',cta:'GET SPARK FOR $99 →'},
    m3:{summary:'Selected: <b>Subscription · 3‑Month Supply · $249</b>. Save $198 vs one‑time, lowest per‑dose price, free shipping, cancel anytime. Prescription requests require licensed clinician review before fulfillment.',cta:'GET SPARK FOR $249 →'},
    ot:{summary:'Selected: <b>One‑Time · 1‑Month Supply · $149</b>. No renewal, same clinician review path, discreet fulfillment if approved.',cta:'GET SPARK FOR $149 →'}
  };
  var sum=document.getElementById('bbSummary'),cta=document.getElementById('bbCta');
  var tabSub=document.getElementById('tabSub'),tabOne=document.getElementById('tabOne');
  var subPlans=document.getElementById('subPlans'),onePlans=document.getElementById('onePlans');
  function apply(key){sum.innerHTML=plans[key].summary;cta.textContent=plans[key].cta;}
  document.querySelectorAll('#subPlans .plan').forEach(function(pl){
    pl.addEventListener('click',function(){
      document.querySelectorAll('#subPlans .plan').forEach(function(x){x.classList.remove('selected')});
      pl.classList.add('selected');apply(pl.dataset.plan);
    });
  });
  tabSub.addEventListener('click',function(){
    tabSub.classList.add('active');tabOne.classList.remove('active');
    subPlans.style.display='';onePlans.style.display='none';
    apply(document.querySelector('#subPlans .plan.selected').dataset.plan);
  });
  tabOne.addEventListener('click',function(){
    tabOne.classList.add('active');tabSub.classList.remove('active');
    subPlans.style.display='none';onePlans.style.display='';
    apply('ot');
  });
})();

// Sticky desktop header after hero
var head=document.getElementById('stickyHead');
window.addEventListener('scroll',function(){
  if(window.scrollY>650){head.classList.add('show')}else{head.classList.remove('show')}
},{passive:true});

// Shopify-native Spark cart wiring
(function(){
  var wrapper = document.querySelector('.amie-static-page[data-amie-spark-offer-campaign]');
  var campaign = (wrapper && wrapper.getAttribute('data-amie-spark-offer-campaign')) || 'spark_offer';
  var config = {
    m1: { id: 49309993337069, qty: 1, selling_plan: 9595027693, content: 'subscription_1mo' },
    m3: { id: 49436001763565, qty: 1, selling_plan: 9595093229, content: 'subscription_3mo' },
    ot: { id: 50091543363821, qty: 1, content: 'one_time_1mo' }
  };
  var links = {
    m1: '/cart/49309993337069:1?selling_plan=9595027693&storefront=true&utm_source=lander&utm_medium=paid_offer&utm_campaign=' + encodeURIComponent(campaign) + '&utm_content=subscription_1mo',
    m3: '/cart/49436001763565:1?selling_plan=9595093229&storefront=true&utm_source=lander&utm_medium=paid_offer&utm_campaign=' + encodeURIComponent(campaign) + '&utm_content=subscription_3mo',
    ot: '/cart/50091543363821:1?storefront=true&utm_source=lander&utm_medium=paid_offer&utm_campaign=' + encodeURIComponent(campaign) + '&utm_content=one_time_1mo'
  };
  var selected = 'm1';
  function setSelected(key){ selected = links[key] ? key : 'm1'; }
  function activeSubPlan(){
    var el = document.querySelector('#subPlans .plan.selected');
    return el && el.dataset && el.dataset.plan ? el.dataset.plan : 'm1';
  }
  function cartUrl(key){
    var item = config[key] || config.m1;
    return '/cart?storefront=true&utm_source=lander&utm_medium=paid_offer&utm_campaign=' + encodeURIComponent(campaign) + '&utm_content=' + encodeURIComponent(item.content);
  }
  function addThenCart(key){
    var item = config[key] || config.m1;
    var payload = { id: item.id, quantity: item.qty };
    if (item.selling_plan) payload.selling_plan = item.selling_plan;
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function(res){
      if (!res.ok) throw new Error('cart add failed');
      window.location.href = cartUrl(key);
    }).catch(function(){
      window.location.href = links[key] || links.m1;
    });
  }
  document.addEventListener('click', function(evt){
    var plan = evt.target.closest && evt.target.closest('.plan[data-plan]');
    if (plan) setSelected(plan.dataset.plan);
    if (evt.target.closest && evt.target.closest('#tabSub')) setSelected(activeSubPlan());
    if (evt.target.closest && evt.target.closest('#tabOne')) setSelected('ot');
    if (evt.target.closest && evt.target.closest('#bbCta')) {
      evt.preventDefault();
      addThenCart(selected);
    }
  }, true);
  window.addEventListener('DOMContentLoaded', function(){
    document.documentElement.classList.add('amie-static-rendered');
    document.documentElement.setAttribute('data-amie-spark-offer-campaign', campaign);
    var cta = document.getElementById('bbCta');
    if (cta) {
      cta.setAttribute('data-cart-link-subscription', links.m1);
      cta.setAttribute('data-cart-link-one-time', links.ot);
    }
  });
})();

})();
